module.exports = __webpack_public_path__ + "img/syl_gallery8.9e927e49.jpg";